import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type AtlassianIntelligenceInProgressFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id' | 'creationMethod' | 'creationMethodError' | 'creationMethodLoadingStartedAt'>
  & { badges: (
    { __typename: 'Card_Badges' }
    & Pick<Types.Card_Badges, 'lastUpdatedByAi'>
  ) }
);

export const AtlassianIntelligenceInProgressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AtlassianIntelligenceInProgress' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'badges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastUpdatedByAi' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'creationMethod' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creationMethodError' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creationMethodLoadingStartedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseAtlassianIntelligenceInProgressFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      AtlassianIntelligenceInProgressFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseAtlassianIntelligenceInProgressFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<AtlassianIntelligenceInProgressFragment>,
    'data'
  > {
  data?: AtlassianIntelligenceInProgressFragment;
}

export const useAtlassianIntelligenceInProgressFragment = ({
  from,
  returnPartialData,
  ...options
}: UseAtlassianIntelligenceInProgressFragmentOptions): UseAtlassianIntelligenceInProgressFragmentResult => {
  const result = Apollo.useFragment<AtlassianIntelligenceInProgressFragment>({
    ...options,
    fragment: AtlassianIntelligenceInProgressFragmentDoc,
    fragmentName: 'AtlassianIntelligenceInProgress',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as AtlassianIntelligenceInProgressFragment,
  };
};
